import React from 'react'

const PencilIcon = ({width="16", height="16"}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.5207 1.18369C11.4323 0.272103 12.9103 0.272105 13.8219 1.18369L14.8163 2.17814C15.7279 3.08973 15.7279 4.5677 14.8163 5.47928L5.47928 14.8163C5.04152 15.2541 4.4478 15.5 3.82871 15.5H1.13662C0.785023 15.5 0.5 15.215 0.5 14.8634V12.1713C0.5 11.5522 0.74593 10.9585 1.18369 10.5207L10.5207 1.18369ZM12.9215 2.084C12.5072 1.66964 11.8354 1.66964 11.421 2.084L9.67631 3.82871L12.1713 6.32369L13.916 4.57897C14.3304 4.16462 14.3304 3.49281 13.916 3.07846L12.9215 2.084ZM11.271 7.224L8.776 4.72902L2.084 11.421C1.88502 11.62 1.77323 11.8899 1.77323 12.1713V14.2268H3.82871C4.11011 14.2268 4.37999 14.115 4.57897 13.916L11.271 7.224Z" fill="#18488A"/>
</svg>

  )
}

export default PencilIcon